export default {
    props: {
        initIsActive: {
            default: false,
            type: Boolean
        },
        initIsColored: {
            default: false,
            type: Boolean
        },
        disableActiveScroll: {
            default: false,
            type: Boolean
        }
    },

    data() {
        return {
            isActive: this.initIsActive,
            isColored: this.initIsColored,
            activeDropdownID: null,
            scrollActiveOffset: 20,
            windowScrollY: 0
        };
    },

    watch: {
        hasActiveDropdown(hasActiveDropdown) {
            if (hasActiveDropdown === true) {
                this.isActive = true;
            } else {
                this.isActive = this.inScrollActiveArea;
            }
        },

        windowScrollY(windowScrollY) {
            this.isActive = this.inScrollActiveArea || this.hasActiveDropdown;
        }
    },

    computed: {
        dynamicStyle() {
            return {
                "text-white": !this.isActive && !this.isColored,
                "bg-white border-b border-light-blue-3": this.isActive
            };
        },

        hasActiveDropdown() {
            return this.activeDropdownID !== null;
        },

        inScrollActiveArea() {
            return this.windowScrollY > this.scrollActiveOffset;
        }
    },

    methods: {
        openHoverMenu() {
            Event.$emit("hover-menu:open");
        }
    },

    created() {
        if (!this.disableActiveScroll) {
            window.onscroll = () => (this.windowScrollY = window.scrollY);
        }
    }
};
